import { conceptCategories, shippingConcept } from '@/returns/constants'

import { conceptNames, customLogisticsLabelConcept, labeledAmountsKey } from './constants'

export const getConceptName = ({ key, customLogisticsLabel, t }) => {
  if (key === customLogisticsLabelConcept && customLogisticsLabel) return customLogisticsLabel

  return t(conceptNames[key])
}

const getConceptCategory = amount => {
  return Number(amount) < 0 ? conceptCategories.fee : conceptCategories.amountToReturn
}

export const getAvailableConcepts = ({
  refundAmounts,
  initialSelectedValue = false,
  shippingSummaryAmount = 0,
  customLogisticsLabel,
  t,
}) => {
  return Object.entries(refundAmounts)
    .filter(([key, value]) => key !== labeledAmountsKey && Number(value) !== 0)
    .map(([key, amount]) => {
      return {
        id: key,
        concept: key,
        label: getConceptName({ key, customLogisticsLabel, t }),
        amount,
        selected: key === shippingConcept ? shippingSummaryAmount > 0 : initialSelectedValue,
        category: getConceptCategory(amount),
      }
    })
}
